__webpack_require__.p = "/algososh/";